<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let items = [];
</script>

<svg
   width="256"
   height="256"
   viewBox="0 0 33.866664 33.866668"
   version="1.1"
   id="svg26212"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs26209">
    <linearGradient
       id="linearGradient1">
      <stop
         style="stop-color:#000000;stop-opacity:1;"
         offset="0.5252952"
         id="stop1" />
      <stop
         style="stop-color:#1b0909;stop-opacity:0.7584098;"
         offset="0.76617956"
         id="stop3" />
      <stop
         style="stop-color:#361212;stop-opacity:0;"
         offset="1"
         id="stop2" />
    </linearGradient>
    <radialGradient
       xlink:href="#linearGradient1"
       id="radialGradient5"
       cx="16.933332"
       cy="16.933331"
       fx="16.933332"
       fy="16.933331"
       r="16.933332"
       gradientUnits="userSpaceOnUse" />
    <radialGradient
       xlink:href="#linearGradient1"
       id="radialGradient2"
       gradientUnits="userSpaceOnUse"
       cx="16.933332"
       cy="16.933331"
       fx="16.933332"
       fy="16.933331"
       r="16.933332" />
    <radialGradient
       xlink:href="#linearGradient1"
       id="radialGradient3"
       gradientUnits="userSpaceOnUse"
       cx="16.933332"
       cy="16.933331"
       fx="16.933332"
       fy="16.933331"
       r="16.933332" />
    <radialGradient
       xlink:href="#linearGradient1"
       id="radialGradient4"
       gradientUnits="userSpaceOnUse"
       cx="16.933332"
       cy="16.933331"
       fx="16.933332"
       fy="16.933331"
       r="16.933332" />
    <radialGradient
       xlink:href="#linearGradient1"
       id="radialGradient6"
       gradientUnits="userSpaceOnUse"
       cx="16.933332"
       cy="16.933331"
       fx="16.933332"
       fy="16.933331"
       r="16.933332" />
    <radialGradient
       xlink:href="#linearGradient1"
       id="radialGradient7"
       gradientUnits="userSpaceOnUse"
       cx="16.933332"
       cy="16.933331"
       fx="16.933332"
       fy="16.933331"
       r="16.933332" />
  </defs>
  <g
     id="layer3"
     style="display:inline">
    <path
       style="stroke-width:0.264583;stroke-linejoin:bevel"
       d="M 14.241508,22.653914 8.9503581,31.81873 a 16.933332,16.933331 0 0 0 7.9829749,2.047937 16.933332,16.933331 0 0 0 8.004163,-2.011764 l -5.312337,-9.200989 a 6.3499999,6.3499994 0 0 1 -0.208256,0.113172 6.3499994,6.349998 0 0 1 -0.112138,0.04186 6.3499999,6.3499994 0 0 1 -0.981852,0.303857 6.3499994,6.349998 0 0 1 -0.247531,0.05426 6.3499999,6.3499994 0 0 1 -1.142049,0.116272 6.3499999,6.3499994 0 0 1 -1.13068,-0.114205 6.3499994,6.349998 0 0 1 -0.254248,-0.05529 6.3499999,6.3499994 0 0 1 -0.940511,-0.287838 6.3499994,6.349998 0 0 1 -0.149862,-0.05581 6.3499999,6.3499994 0 0 1 -0.216524,-0.116272 z"
       id="button5"
       class="button"
       class:grayed={items[5]?.grayed}
       on:pointerup={() => dispatch('click', 5)} />
    <path
       style="stroke-width:0.264583;stroke-linejoin:bevel"
       d="m 23.22959,17.4625 a 6.3499999,6.3499994 0 0 1 -0.06253,0.612882 6.3499994,6.349998 0 0 1 -0.05426,0.247531 6.3499999,6.3499994 0 0 1 -0.303857,0.981852 6.3499994,6.349998 0 0 1 -0.04186,0.112138 6.3499999,6.3499994 0 0 1 -0.584461,1.072802 6.3499999,6.3499994 0 0 1 -10e-4,0.0021 6.3499994,6.349998 0 0 1 -1.633492,1.643311 l 5.304069,9.187553 A 16.933332,16.933331 0 0 0 33.853748,17.4625 Z"
       id="button4"
       class="button"
       class:grayed={items[4]?.grayed}
       on:pointerup={() => dispatch('click', 4)} />
    <path
       style="stroke-width:0.264583;stroke-linejoin:bevel"
       d="m 0.0377238,17.4625 a 16.933332,16.933331 0 0 0 7.983492,13.848767 L 13.3196,22.134049 a 6.3499994,6.349998 0 0 1 -1.613338,-1.614371 6.3499999,6.3499994 0 0 0 0,-5.17e-4 6.3499999,6.3499994 0 0 1 -0.605131,-1.097091 6.3499994,6.349998 0 0 1 -0.02119,-0.05736 6.3499999,6.3499994 0 0 1 -0.326078,-1.041796 6.3499994,6.349998 0 0 1 -0.05064,-0.232028 6.3499999,6.3499994 0 0 1 -0.06511,-0.628385 z"
       id="button3"
       class="button"
       class:grayed={items[3]?.grayed}
       on:pointerup={() => dispatch('click', 3)} />
    <path
       style="stroke-width:0.264583;stroke-linejoin:bevel"
       d="M 8.0212158,2.5553996 A 16.933332,16.933331 0 0 0 0.0377238,16.404167 H 10.637594 a 6.3499999,6.3499994 0 0 1 0.06305,-0.617017 6.3499994,6.349998 0 0 1 0.05168,-0.237712 6.3499999,6.3499994 0 0 1 0.309025,-0.997871 6.3499994,6.349998 0 0 1 0.03617,-0.09715 6.3499999,6.3499994 0 0 1 0.587561,-1.079004 6.3499994,6.349998 0 0 1 1.634009,-1.643827 z"
       id="button1"
       class="button"
       class:grayed={items[1]?.grayed}
       on:pointerup={() => dispatch('click', 1)} />
    <path
       style="stroke-width:0.264583;stroke-linejoin:bevel"
       d="m 25.852169,2.5440308 -5.298902,9.1777342 a 6.3499994,6.349998 0 0 1 1.65468,1.676384 6.3499999,6.3499994 0 0 1 0.589628,1.099674 6.3499999,6.3499994 0 0 1 0.362768,1.191659 6.3499999,6.3499994 0 0 1 5.17e-4,0.0021 6.3499994,6.349998 0 0 1 5.17e-4,0.0031 6.3499999,6.3499994 0 0 1 0.09973,0.709518 H 33.853748 A 16.933332,16.933331 0 0 0 25.852169,2.5440308 Z"
       id="button2"
       class="button"
       class:grayed={items[2]?.grayed}
       on:pointerup={() => dispatch('click', 2)} />
    <path
       style=";stroke-width:0.264583;stroke-linejoin:bevel"
       d="M 16.933333,0 A 16.933332,16.933331 0 0 0 8.9503581,2.047937 l 5.2916669,9.165332 a 6.3499999,6.3499994 0 0 1 0.21239,-0.115755 6.3499994,6.349998 0 0 1 0.09715,-0.03617 6.3499999,6.3499994 0 0 1 0.997871,-0.309025 6.3499994,6.349998 0 0 1 0.237712,-0.05168 6.3499999,6.3499994 0 0 1 1.146183,-0.117306 6.3499999,6.3499994 0 0 1 1.263489,0.127641 6.3499999,6.3499994 0 0 1 0.001,0 6.3499994,6.349998 0 0 1 0.001,5.17e-4 6.3499999,6.3499994 0 0 1 1.212846,0.376721 6.3499999,6.3499994 0 0 1 0.216524,0.118856 L 24.937496,2.0117635 A 16.933332,16.933331 0 0 0 16.933333,0 Z"
       id="button0"
       class="button"
       class:grayed={items[0]?.grayed}
       on:pointerup={() => dispatch('click', 0)} />
  </g>
</svg>

<style>
    .button {
        fill:url(#radialGradient5)
    }

    .button:not(.grayed):hover {
        fill: rgba(127, 127, 63, 0.95);
    }
</style>
